import React from 'react';

const UnauthorizedPage = () => {
    return <div className='text-center'>
        Unauthorized Page
    </div>
}

export default UnauthorizedPage;